import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from "../Context/CartContext";
import { GARDEN_FURNITURE_IMAGES } from '../utils/imageUrls';

const projects = [
    {
        id: 10,
        title: "ספסל גינה",
        mainImage: GARDEN_FURNITURE_IMAGES.bench,
        galleryImages: GARDEN_FURNITURE_IMAGES.benchGallery,
        sizes: ['60X45, גובה: 90 ', '120X45, גובה: 90', '180X45, גובה: 90'],
        woodTypes: ['אורן'],
        price: "החל מ-₪300"
    },
    {
        id: 11,
        title: "שולחנות גן",
        mainImage: GARDEN_FURNITURE_IMAGES.table,
        galleryImages: GARDEN_FURNITURE_IMAGES.tableGallery,
        sizes: ['180X120, שולחן כבד: גובה: 90','שולחן קק"ל: 165X160, גובה 80'],
        woodTypes: ['אורן'],
        price: "החל מ-₪900"
    },
    {
        id: 12,
        title: "נדנדות גן",
        mainImage: GARDEN_FURNITURE_IMAGES.swing,
        galleryImages: GARDEN_FURNITURE_IMAGES.swingGallery,
        sizes: ['180X160, גובה: 200','נדנדה עם גגון: 180X160, גובה: 200 '],
        woodTypes: ['אורן'],
        price: "החל מ-₪1750"
    },
    {
        id: 13,
        title: "פינות ישיבה",
        mainImage: GARDEN_FURNITURE_IMAGES.seatingArea,
        galleryImages: GARDEN_FURNITURE_IMAGES.seatingAreaGallery,
        sizes: ['ללא משענת: 120X28, גובה: 45','שולחן פינות ישיבה: 100X60, גובה 45','ללא משענת: 180X28, גובה: 45'],
        woodTypes: ['אורן'],
        price: "החל מ-₪350"
    },
    {
        id: 15,
        title: "מחזיק עצים גינה",
        mainImage: GARDEN_FURNITURE_IMAGES.woodHolder,
        galleryImages: GARDEN_FURNITURE_IMAGES.woodHolderGardenGallery,
        sizes: ['100X45, גובה: 90'],
        woodTypes: ['אורן'],
        price: "₪600"
    }
];

export { projects };

function GardenFurniture() {
    const { addToItem } = useContext(CartContext);
    const navigate = useNavigate();

    const handleClick = (project) => {
        addToItem(project);
        navigate(`/product-page/${project.id}`, { state: { project } });
    };

    return (
        <div className="py-10 px-4 sm:px-6 lg:px-8 bg-background flex flex-col items-center">

            <div className="text-center mb-10">
                <h1 className="text-3xl md:text-5xl font-medium text-text-primary tracking-wide mb-4">
                    ריהוט גינה
                </h1>
                <div className="w-16 h-1 bg-accent mx-auto rounded-full"></div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 w-full max-w-7xl mx-auto">
                {projects.map(project => (
                    <div
                        key={project.id}
                        onClick={() => handleClick(project)}
                        className="group bg-surface rounded-2xl overflow-hidden shadow-soft hover:shadow-hover cursor-pointer transition-all duration-500 flex flex-col border border-transparent hover:border-secondary-dark"
                    >
                        <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
                            <img
                                src={project.mainImage}
                                alt={project.title}
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
                        </div>

                        <div className="p-6 text-center flex flex-col flex-grow justify-between bg-surface z-10 relative">
                            <div>
                                <h2 className="text-xl md:text-2xl font-medium text-text-primary mb-1">
                                    {project.title}
                                </h2>
                                <p className="text-text-secondary text-sm font-light">
                                    {project.price}
                                </p>
                            </div>
                            <div className="w-8 h-0.5 bg-secondary-dark mx-auto mt-6 transition-all duration-300 group-hover:w-16 group-hover:bg-accent" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GardenFurniture;